const privacyTypes = [
  { title: 'Public' },
  { title: 'Private' },
];

const privacyTypes2 = [
  { id: 1, title: 'public', description: 'Anyone can search for and view', current: true },
  { id: 0, title: 'private', description: 'Only you can view' , current: false },
];

const ceClipsItems = [
  {
    id: 0,
    title: 'HSLHS BTS',
    src: '/videos/5.mp4',
    description: 'What is the relationship between Christianity and religion?',
    channelID: '3034',
    channelName: '@Kingfluencer',
    channelProfilePicture: '/images/kingfluencer.webp',
    views: 34241,
    likes: 1000,
    comments: 20,
    poster: '/images/ceclips/5.png',
  },
  {
    id: 1,
    title: 'Why I gave my life to Christ',
    src: '/videos/0.mp4',
    description: 'What is the relationship between Christianity and religion?',
    channelID: '3034',
    channelName: '@Kingfluencer',
    channelProfilePicture: '/images/kingfluencer.webp',
    views: 213441,
    likes: 23400,
    comments: 20,
    poster: '/images/ceclips/0.png',
  },
  {
    id: 2,
    src: '/videos/1.mp4',
    title: 'How to make shephards Pie',
    description: 'What is the relationship between Christianity and religion?',
    channelID: '3034',
    channelName: '@Kingfluencer',
    channelProfilePicture: '/images/kingfluencer.webp',
    views: 213441,
    likes: 23400,
    comments: 20,
    poster: '/images/ceclips/1.png',
  },
  {
    id: 3,
    title: 'Abraham and Sarah',
    src: '/videos/3.mp4',
    description: 'What is the relationship between Christianity and religion?',
    channelID: '3034',
    channelName: '@Kingfluencer',
    channelProfilePicture: '/images/kingfluencer.webp',
    views: 213441,
    likes: 23400,
    comments: 20,
    poster: '/images/ceclips/3.png',
  },
  {
    id: 4,
    title: 'BLW Rivers Of Grace Evangelism',
    src: '/videos/4.mp4',
    description: 'What is the relationship between Christianity and religion?',
    channelID: '3034',
    channelName: '@Kingfluencer',
    channelProfilePicture: '/images/kingfluencer.webp',
    views: 213441,
    likes: 23400,
    comments: 20,
    poster: '/images/ceclips/4.png',
  }
];

export {
  privacyTypes,
  privacyTypes2,
  ceClipsItems
};
